import { getBasicWebsiteInfoByCTX } from 'src/pageUtils/commonUtils/ctxUtils';
import { PATH } from './routes';
import { REDIRECTION_STATUS_CODE_MAP } from 'src/constants/common';
import { getSSRStoreData } from './ssrPageData';

/**
 * function used to redsirect to 404 page on any issue in
 * ssr conditions
 * @param {*} ctx
 */
export const _404Redirect = (ctx, statusCode = 302) => {
  let location = '/404';
  const { domainByParams, isPreviewRoute } = getBasicWebsiteInfoByCTX(ctx);
  if (domainByParams) {
    if (isPreviewRoute)
      location = `/${PATH.BUILDER_PREVIEW}/${ctx?.params?.pid}/${PATH._404}`;
    else location = `/${domainByParams + `/${PATH._404}`}`;
  }
  ctx.res.writeHead(statusCode, { location });
  ctx.res.end();
  return { props: {} };
};
export const set404Response = async (ctx, propType = null) => {
  const { res } = ctx;

  if (!propType) {
    propType = await getSSRStoreData(ctx, {
      additionalDataToFetch: ['collections', 'categories'],
    });
  }

  if (res) {
    res.statusCode = 404;
  }

  return {
    props: {
      ...propType,
      notFound: true,
    },
  };
};

/**
 *
 * @param {Object} argmnt
 * @param {Object} ctx
 * @param {String | Number} statusCode
 * @param {String} route
 * @param {Boolean} isPermanentRedirect
 * @returns
 */
export const _redirectToOtherRoute = (argmnt) => {
  const returnProps = { props: {} };
  const {
    ctx,
    statusCode = REDIRECTION_STATUS_CODE_MAP.MOVED_TEMPORARILY,
    route,
    isPermanentRedirect = false,
  } = argmnt;

  if (!ctx) return returnProps;

  let responseStatusCode = statusCode;
  if (!statusCode) {
    responseStatusCode = REDIRECTION_STATUS_CODE_MAP.MOVED_TEMPORARILY;
  }
  if (isPermanentRedirect) {
    responseStatusCode = REDIRECTION_STATUS_CODE_MAP.PERMANENT_REDIRECT;
  }

  ctx.res.writeHead(responseStatusCode, { location: route });
  ctx.res.end();
  return returnProps;
};

export const checkIfRoutesAreValid = (isCustomDomain, ctx) => {
  if (!isCustomDomain) {
    const splittedUrl = ctx.req.url.split('/');
    const route = splittedUrl?.[2];

    if (route === '_next') {
      return;
    }

    if (route?.includes('?')) {
      return;
    }

    if (!route) {
      return true;
    }

    if (ctx?.params?.domain) {
      return true;
    }

    if (!VALID_PATHS?.[route]) {
      _404Redirect(ctx);
      return false;
    }
  } else {
    const splittedUrl = ctx.req.url.split('/');
    const route = splittedUrl?.[1];

    if (route === '_next') {
      return;
    }

    if (route?.includes('?')) {
      return;
    }

    if (!route) {
      return true;
    }

    if (ctx?.params?.domain) {
      return true;
    }

    if (!VALID_PATHS?.[route]) {
      _404Redirect(ctx);
      return false;
    }
  }
  return true;
};

const VALID_PATHS = {
  'about-us': true,
  'add-delivery': true,
  blog: true,
  cart: true,
  categories: true,
  collections: true,
  'delivery-details': true,
  'delivery-list': true,
  'emi-options': true,
  'emi-payment': true,
  'member-login': true,
  'offers-list': true,
  'order-confirm': true,
  'order-receipt': true,
  'order-status': true,
  orders: true,
  p: true,
  payment: true,
  'payment-failed': true,
  'payment-process': true,
  policy: true,
  product: true,
  search: true,
  shop: true,
  store: true,
  'store-close': true,
  thankyou: true,
  'verify-otp': true,
  widgets: true,
  api: true,
  wishlist: true,
};
